import { render } from "./providerBasedReservations.vue?vue&type=template&id=181daa07&scoped=true"
import script from "./providerBasedReservations.vue?vue&type=script&lang=js"
export * from "./providerBasedReservations.vue?vue&type=script&lang=js"

import "./providerBasedReservations.vue?vue&type=style&index=0&id=181daa07&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181daa07"]])

export default __exports__